<div class="container">
  <span matSnackBarLabel class="left">
    {{data.message}}
  </span>
  <span matSnackBarActions class="right">
    <button mat-icon-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      <mat-icon style="color: white;">{{data.icon}}</mat-icon>
    </button>
  </span>
</div>